import isMobile from 'ismobilejs'
import { Platform } from 'react-native'

export const isMobileBrowser = () => Platform.OS === 'web' && isMobile(window.navigator).any
